import { INIT, SPLICE, PUSH, SET_INDEX, SET_AVATAR_IMG_BY_INDEX, SET_FIRSTNAME_BY_INDEX, SET_GENDER_BY_INDEX,
  SET_LASTNAME_BY_INDEX, SET_BIRTH_DATE_BY_INDEX, SET_BIRTH_YEAR_BY_INDEX,
  SET_FACEBOOK_URL_BY_INDEX, SET_INSTAGRAM_URL_BY_INDEX, SET_LOADING_STATUS, SET_STATUS_MESSAGE,
  CLEAR, SET_TOTAL_COUNT } from
  './mutation-types'
import { SET_SEARCHING_STATUS, SET_PROGRESS_VALUE, SET_ORGANIZATION_BY_INDEX, SET_TITLE_BY_INDEX,
  SET_GROUP_BY_INDEX, SET_CATEGORY_BY_INDEX, SET_DESCRIPTION_BY_INDEX, UPDATE_CONTACT_MESSAGE,
  ARCHIVE_CONTACT_BY_INDEX, SET_HASUNREAD_BY_INDEX, SET_QUERYING_UPDATE_NEW_CONTACT,
  SET_QUERY_UPDATE_NEW_CONTACT_DISABLED, SET_CONTACT_SELECTED_BY_INDEX,
  SET_PENDING_STATUS_CODE_BY_INDEX,
  UPDATE_CONTACTS_PENDING_STATUS_CODE,
  SET_QUERY_COUNT, INIT_SEARCH, CLEAR_SEARCH
}
  from './contact-mutation-types'
import { apolloClient } from '@/plugins/apollo/apolloUploadClient'
import { UPDATE_CONTACT, UPLOAD_CONTACT_AVATAR, UPLOAD_CONTACTS } from '@/backend/graphql/contactGQL'
import store from '@/store'
import _ from 'lodash'
import libphonenumber from 'google-libphonenumber'
import { isInboundMessage } from '@/store/modules/message'
import moment from 'moment-timezone'
import { getContactImg } from '@/store/utils'

const PendingStatusMessage = ['normal', 'Pending Send', 'Pending Reply', 'Been Contacted', 'Failed', 'Undelivered']

const state = {
  allContacts: [],
  contactIndex: 0,
  totalCount: 0,
  queriedContacts: [],
  totalQueriedCount: 0,
  status: {
    loading: false,
    message: 'Loading',
    progressValue: 0,
    searching: false
  },
  queryNewContactByNumberVariables: null,
  queryingNewContact: false,
  queryNewContactDisabled: true
}

// noinspection JSAnnotator
export const getQueryContactNumber = (number) => {
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
  try {
    const numberInstance = phoneUtil.parseAndKeepRawInput(number, 'US')
    return `+${numberInstance.getCountryCode()} ${numberInstance.getNationalNumber()}`
  } catch (e) {
    console.error(number, e)
    return ''
  }
}

function prependZerosToBirthDate (birthDate) {
  const prependZeros = '0'.repeat(4 - birthDate.length)
  return prependZeros + birthDate
}

function cleanUpData (data, acceptedKeys) {
  if (_.isEmpty(acceptedKeys)) return
  for (const key of Object.keys(data)) {
    cleanUpDataByKey(data, key, acceptedKeys)
    cleanUpData(data[key], getAcceptedKeys(key))
  }
}

function getAcceptedKeys (objectName) {
  let acceptedKeys = []
  switch (objectName) {
    case 'contact':
      acceptedKeys = ['id', 'number', 'name', 'lastName', 'facebookUrl',
        'instagramUrl', 'birthyear', 'gender', 'bdayTags', 'description', 'hasInbox', 'hasUnread',
        'groupSet', 'categorySet', 'profileWorkHistory']
      break
    case 'bdayTag':
      acceptedKeys = ['id', 'intValue', 'strValue', 'name']
      break
    case 'profileWorkHistory':
      acceptedKeys = ['id', 'organization', 'title']
      break
    case 'title':
      acceptedKeys = ['id', 'name']
      break
    case 'organization':
      acceptedKeys = ['id', 'name', 'city', 'state']
      break
    case 'groupSet':
      acceptedKeys = ['id', 'name']
      break
    case 'categorySet':
      acceptedKeys = ['id', 'name']
      break
    default:
      break
  }
  return acceptedKeys
}

function cleanUpDataByKey (data, key, acceptedKeys) {
  if (!acceptedKeys.includes(key)) {
    delete data[key]
  }
}

function isValidContactIndex (state, index) {
  return index >= 0 && index < state.allContacts.length
}

function isValidContact (state, index) {
  return (isValidContactIndex(state, index)) ? (!!state.allContacts[index]) : false
}

function processBdayData (bdayData) {
  if (!bdayData) return null
  const acceptedKeys = getAcceptedKeys('bdayTag')
  let isBdayDataValid = true
  for (const bdayKey of Object.keys(bdayData)) {
    cleanUpDataByKey(bdayData, bdayKey, acceptedKeys)
    if (bdayKey === 'strValue' && bdayData.hasOwnProperty(bdayKey)) {
      // make sure the strValue is a valid birthday
      const bdayInt = parseInt(validateBdayStr(bdayData[bdayKey]))
      if (bdayInt < 0) {
        isBdayDataValid = false
        break
      } else {
        bdayData['intValue'] = bdayInt
      }
    }
  }
  return isBdayDataValid ? bdayData : null
}

function validateBdayStr (val) {
  if (val.length < 4) val = prependZerosToBirthDate(val)
  const month = val.substring(0, 2)
  const days = val.substring(2)
  if (parseInt(month) > 12 || parseInt(month) < 0) return '-1'
  if (parseInt(days) > 31 || parseInt(month) < 0) return '-1'
  return val
}

const getters = {
  getQueryingNewContact: (state) => {
    return state.queryingNewContact
  },
  getQueryingNewContactDisabled: (state) => {
    return state.queryNewContactDisabled
  },
  getQueryNewContactByNumberVariables: (state) => {
    return state.queryNewContactByNumberVariables
  },
  getLoadingStatus: (state) => {
    return state.status.loading
  },
  getLoadingText: (state) => {
    return state.status.message
  },
  getProgressValue: (state) => {
    return state.status.progressValue
  },
  getSearchingStatus: (state) => {
    return state.status.searching
  },
  getContactIndex: (state) => {
    return state.contactIndex
  },
  getCurrentContact: (state) => (index) => {
    if (!isValidContact(state, index)) return null
    return state.allContacts[index]
  },
  getIdByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.id
  },
  getNumberByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.number
  },
  getFirstNameByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.name
  },
  getLastNameByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.lastName
  },
  getBirthDateByIndex: (state) => (index, isEdited) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    const bdayTags = contact.bdayTags
    if (bdayTags && bdayTags.length > 0 && bdayTags[bdayTags.length - 1].name === 'birthday') {
      const birthDate = state.allContacts[index].bdayTags[bdayTags.length - 1].strValue
      if (isEdited) return birthDate
      else return birthDate.length < 4 ? prependZerosToBirthDate(birthDate) : birthDate
    } else {
      return ''
    }
  },
  getHasInboxByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.hasInbox
  },
  getHasUnreadByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.hasUnread
  },
  getBirthYearByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.birthyear
  },
  getFacebookUrlByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.facebookUrl
  },
  getInstagramUrlByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return contact.instagramUrl
  },
  getAvatarImgByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const contact = state.allContacts[index]
    return getContactImg(contact)
  },
  getGenderByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return 0
    return !state.allContacts[index].gender ? 0 : state.allContacts[index].gender
  },
  getOrganizationByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return null
    const profileWork = state.allContacts[index].profileWorkHistory
    return profileWork.length === 0 ? null : profileWork[profileWork.length - 1].organization === null ? null
      : profileWork[profileWork.length - 1].organization.name
  },
  getTitleByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return null
    const profileWork = state.allContacts[index].profileWorkHistory
    return profileWork.length === 0 ? null : profileWork[profileWork.length - 1].title === null ? null
      : profileWork[profileWork.length - 1].title.name
  },
  getDescriptionByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    return state.allContacts[index].description
  },
  getPendingMessageByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return ''
    const status = state.allContacts[index].pendingStatus
    return status < PendingStatusMessage.length ? PendingStatusMessage[status] : 'Unknown'
  },
  getCategoriesByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return []
    return _.get(state.allContacts[index], 'categorySet', [])
  },
  getGroupsByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return []
    return _.get(state.allContacts[index], 'groupSet', [])
  },
  getContactSelectedByIndex: (state) => (index) => {
    if (!isValidContact(state, index)) return false
    return _.get(state.allContacts[index], 'selected', false)
  },
  getAllContacts: (state) => {
    return state.allContacts
  },
  getQueriedContacts: (state) => {
    return state.queriedContacts
  },
  getTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  async init ({ commit }, { newContacts, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_TOTAL_COUNT, { val: totalCount })
      commit(INIT, { newContacts, totalCount: isFullArraySize ? totalCount : newContacts.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  // index is the current index
  async next ({ commit }, { newContacts, startIndex, setIndex, updateMessage }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      const newContactObjects = JSON.parse(JSON.stringify(newContacts))
      commit(SPLICE, { newContactObjects, startIndex, deleteCount: newContactObjects.length })
      commit(SET_INDEX, { val: setIndex })
      if (updateMessage) { store.dispatch('messageDrawer/setItem', { val: state.allContacts[setIndex] }) }
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  // index is the current index
  async prev ({ commit }, { newContacts, startIndex, setIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      const newContactObjects = JSON.parse(JSON.stringify(newContacts))
      commit(SPLICE, { newContactObjects, startIndex, deleteCount: newContactObjects.length })
      commit(SET_INDEX, { val: setIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async unshift ({ commit }, { newContacts, checkInbox }) {
    const newContactObjects = JSON.parse(JSON.stringify(newContacts))
    commit(SPLICE, { newContactObjects, startIndex: 0, deleteCount: 0, checkInbox })
    commit(SET_TOTAL_COUNT, { val: state.totalCount + newContactObjects.length })
    commit(SET_QUERYING_UPDATE_NEW_CONTACT, { val: false })
  },
  async push ({ commit }, newContacts) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(PUSH, newContacts)
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async initSearch ({ commit }, { newContacts, totalCount }) {
    commit(SET_SEARCHING_STATUS, { val: false })
    try {
      commit(SET_QUERY_COUNT, { val: totalCount })
      commit(INIT_SEARCH, { newContacts, totalCount: newContacts.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async appendSearch ({ commit }, { newContacts }) {
    // TODO
  },
  async updateContact ({ commit }, { contactData, index, updateResult = true }) {
    if (!contactData || !contactData.id) return
    let copyContactData = JSON.parse(JSON.stringify(contactData))
    try {
      const acceptedContactKeys = getAcceptedKeys('contact')
      for (const key of Object.keys(copyContactData)) {
        if (key === 'bdayTags' && copyContactData.hasOwnProperty(key)) {
          // copy bday data list
          let lastBday = copyContactData[key][copyContactData[key].length - 1]
          lastBday = processBdayData(lastBday)
          if (!lastBday) {
            // remove bdayTags
            delete copyContactData[key]
          } else {
            copyContactData[key] = [lastBday]
          }
        } else if (key === 'birthyear' && copyContactData.hasOwnProperty(key)) {
          if (copyContactData[key] === '') {
            contactData[key] = '0'
          }
        } else if (key === 'profileWorkHistory' && copyContactData.hasOwnProperty(key)) {
          // create a new profileWorkHistory
          const workHistoryList = []
          if (copyContactData[key].length > 0 && !copyContactData[key][copyContactData[key].length - 1].hasOwnProperty('id')) {
            const workHistory = Object.assign({}, copyContactData[key][copyContactData[key].length - 1])
            cleanUpData(workHistory, getAcceptedKeys(key))
            workHistoryList.push(workHistory)
          }
          copyContactData[key] = workHistoryList
        } else if (key === 'categorySet' && copyContactData.hasOwnProperty(key)) {
          const categorySet = []
          for (const category of copyContactData[key]) {
            cleanUpData(category, getAcceptedKeys(key))
            categorySet.push(category)
          }
          copyContactData[key] = categorySet
        } else if (key === 'groupSet' && copyContactData.hasOwnProperty(key)) {
          const groupSet = []
          for (const group of copyContactData[key]) {
            cleanUpData(group, getAcceptedKeys(key))
            groupSet.push(group)
          }
          copyContactData[key] = groupSet
        } else {
          cleanUpDataByKey(copyContactData, key, acceptedContactKeys)
        }
      }
      const res = await apolloClient.mutate({
        mutation: UPDATE_CONTACT,
        variables: { contactData: copyContactData }
      })
      // set loading status false
      commit(SET_LOADING_STATUS, { val: false })
      if (!res.errors) {
        const message = 'Update Contact Successfully'
        store.dispatch('alert/success', message)
        if (updateResult) {
          const newContacts = [res.data.updateContact.contact]
          const newContactObjects = JSON.parse(JSON.stringify(newContacts))
          commit(SPLICE, { newContactObjects, startIndex: index, deleteCount: newContactObjects.length })
        }
      } else {
        store.dispatch('alert/error', res.errors.message)
      }
    } catch (error) {
      commit(SET_LOADING_STATUS, { val: false })
      store.dispatch('alert/error', error.message)
    }
  },
  async uploadContactAvatarImg ({ commit }, { uploadData, index }) {
    if (!uploadData || !uploadData.id || !uploadData.file) return
    try {
      const res = await apolloClient.mutate({
        mutation: UPLOAD_CONTACT_AVATAR,
        variables: { id: uploadData.id, file: uploadData.file }
      })
      commit(SET_LOADING_STATUS, { val: false })
      if (!res.errors) {
        const message = 'Upload Avatar Successfully'
        store.dispatch('alert/success', message)
        const contact = res.data.uploadContactAvatarImg.contact
        commit(SET_AVATAR_IMG_BY_INDEX, { val: contact.avatarImg, index })
      } else {
        store.dispatch('alert/error', res.errors.message)
      }
    } catch (error) {
      commit(SET_LOADING_STATUS, { val: false })
      store.dispatch('alert/error', error.message)
    }
  },
  async uploadContacts ({ commit }, { contactArray }) {
    if (!contactArray || !contactArray.contacts) return
    try {
      let contacts = []
      for (let i = 0; i < contactArray.contacts.length; i++) {
        const item = contactArray.contacts[i]
        if (i !== 0 && (i % 30) === 0) {
          const res = await apolloClient.mutate({
            mutation: UPLOAD_CONTACTS,
            variables: {
              'contactArray': {
                isOverwritten: contactArray.isOverwritten,
                contacts: contacts,
                groups: contactArray.groups,
                categories: contactArray.categories,
                interests: contactArray.interests
              }
            }
          })
          if (!res.errors) {
            const progress = (i / contactArray.contacts.length) * 100
            commit(SET_PROGRESS_VALUE, { val: progress })
          } else {
            store.dispatch('alert/error', res.errors.message)
          }
          contacts = []
        } else {
          contacts.push(item)
        }
      }

      if (contacts.length > 0) {
        const res = await apolloClient.mutate({
          mutation: UPLOAD_CONTACTS,
          variables: {
            'contactArray': {
              isOverwritten: contactArray.isOverwritten,
              contacts: contacts,
              groups: contactArray.groups,
              categories: contactArray.categories,
              interests: contactArray.interests
            }
          }
        })
        if (!res.errors) {
          // update status bar
          const progress = 100
          commit(SET_PROGRESS_VALUE, { val: progress })
          commit(SET_LOADING_STATUS, { val: false })
          const message = 'Update Contact Successfully'
          store.dispatch('alert/success', message)
        } else {
          store.dispatch('alert/error', res.errors.message)
        }
        contacts = []
      }
    } catch (error) {
      commit(SET_LOADING_STATUS, { val: false })
      store.dispatch('alert/error', error.message)
    }
  },
  async updateContactsPendingStatus ({ commit }, { messageData }) {
    if (_.isEmpty(messageData)) return
    commit(UPDATE_CONTACTS_PENDING_STATUS_CODE, { messageData })
  },
  async updateContactMessage ({ commit }, { smsInstance, statusCode }) {
    if (!smsInstance) return
    commit(UPDATE_CONTACT_MESSAGE, { smsInstance, statusCode })
  },
  async archiveContactByIndex ({ commit }, { index }) {
    commit(ARCHIVE_CONTACT_BY_INDEX, { index })
  },
  setLoadingStatus ({ commit }, { val }) {
    commit(SET_LOADING_STATUS, { val })
  },
  setStatusMessage ({ commit }, { message }) {
    commit(SET_STATUS_MESSAGE, { message })
  },
  setProgressValue ({ commit }, { val }) {
    commit(SET_PROGRESS_VALUE, { val })
  },
  setSearchingStatus ({ commit }, { val }) {
    commit(SET_SEARCHING_STATUS, { val })
  },
  setHasUnreadByIndex ({ commit }, { val, index }) {
    commit(SET_HASUNREAD_BY_INDEX, { val, index })
  },
  setFirstNameByIndex ({ commit }, { val, index }) {
    commit(SET_FIRSTNAME_BY_INDEX, { val, index })
  },
  setLastNameByIndex ({ commit }, { val, index }) {
    commit(SET_LASTNAME_BY_INDEX, { val, index })
  },
  setBirthDateByIndex ({ commit }, { val, index }) {
    commit(SET_BIRTH_DATE_BY_INDEX, { val, index })
  },
  setBirthYearByIndex ({ commit }, { val, index }) {
    commit(SET_BIRTH_YEAR_BY_INDEX, { val, index })
  },
  setFacebookUrlByIndex ({ commit }, { val, index }) {
    commit(SET_FACEBOOK_URL_BY_INDEX, { val, index })
  },
  setInstagramUrlByIndex ({ commit }, { val, index }) {
    commit(SET_INSTAGRAM_URL_BY_INDEX, { val, index })
  },
  setPendingStatusCodeByIndex ({ commit }, { val, index }) {
    commit(SET_PENDING_STATUS_CODE_BY_INDEX, { val, index })
  },
  setOrganizationByIndex ({ commit }, { val, index }) {
    commit(SET_ORGANIZATION_BY_INDEX, { val, index })
  },
  setTitleByIndex ({ commit }, { val, index }) {
    commit(SET_TITLE_BY_INDEX, { val, index })
  },
  setAvatarImgByIndex ({ commit }, { val, index }) {
    commit(SET_AVATAR_IMG_BY_INDEX, { val, index })
  },
  setGenderByIndex ({ commit }, { val, index }) {
    commit(SET_GENDER_BY_INDEX, { val, index })
  },
  setDescriptionByIndex ({ commit }, { val, index }) {
    commit(SET_DESCRIPTION_BY_INDEX, { val, index })
  },
  setCategoryByIndex ({ commit }, { val, index }) {
    commit(SET_CATEGORY_BY_INDEX, { val, index })
  },
  setGroupByIndex ({ commit }, { val, index }) {
    commit(SET_GROUP_BY_INDEX, { val, index })
  },
  setContactSelectedByIndex ({ commit }, { val, index }) {
    commit(SET_CONTACT_SELECTED_BY_INDEX, { val, index })
  },
  setTotalCount ({ commit }, { val }) {
    commit(SET_TOTAL_COUNT, { val })
  },
  setQueryingNewContact ({ commit }, { val }) {
    commit(SET_QUERYING_UPDATE_NEW_CONTACT, { val })
  },
  setQueryNewContactDisabled ({ commit }, { val }) {
    commit(SET_QUERY_UPDATE_NEW_CONTACT_DISABLED, { val })
  },
  setIndex ({ commit }, { val }) {
    commit(SET_INDEX, { val })
  },
  clearSearch ({ commit }) {
    commit(CLEAR_SEARCH)
  },
  clear ({ commit }) {
    commit(CLEAR)
  }
}

const mutations = {
  [SET_LOADING_STATUS] (state, { val }) {
    state.status.loading = val
  },
  [SET_STATUS_MESSAGE] (state, { message }) {
    state.status.message = message
  },
  [SET_SEARCHING_STATUS] (state, { val }) {
    state.status.searching = val
  },
  [SET_PROGRESS_VALUE] (state, { val }) {
    state.status.progressValue = val
  },
  [INIT] (state, { newContacts, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newContacts))
    // convert lastSmsAt to Date object
    // The time zone should be Phoenix
    const cleanedObjs = objs.map((item) => {
      return Object.assign(item, {
        lastSmsAt: moment.tz(item.lastSmsAt, 'America/Phoenix').toDate(),
        size: 60
      })
    })
    state.allContacts = new Array(totalCount)
    state.allContacts.splice(0, cleanedObjs.length, ...cleanedObjs)
    store.dispatch('messageDrawer/setItem', { val: state.allContacts[0] })
  },
  [SPLICE] (state, { newContactObjects, startIndex, deleteCount, checkInbox = false }) {
    if (checkInbox) {
      newContactObjects = newContactObjects.filter((item) => {
        return item.hasInbox
      })
    }
    const cleanedObjs = newContactObjects.map((item) => {
      return Object.assign(item, {
        lastSmsAt: moment.tz(item.lastSmsAt, 'America/Phoenix').toDate(),
        size: 60
      })
    })
    state.allContacts.splice(startIndex, deleteCount, ...cleanedObjs)
  },
  [PUSH] (state, newContacts) {
    const objs = JSON.parse(JSON.stringify(newContacts))
    const cleanedObjs = objs.map((item) => {
      return Object.assign(item, {
        lastSmsAt: moment.tz(item.lastSmsAt, 'America/Phoenix').toDate()
      })
    })
    state.allContacts.push(...cleanedObjs)
  },
  [INIT_SEARCH] (state, { newContacts, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newContacts))
    const cleanedObjs = objs.map((item) => {
      return Object.assign(item, {
        fullName: `${item.name} ${item.lastName}`,
        avatarImg: getContactImg(item)
      })
    })
    state.queriedContacts = new Array(totalCount)
    state.queriedContacts.splice(0, cleanedObjs.length, ...cleanedObjs)
  },
  [ARCHIVE_CONTACT_BY_INDEX] (state, { index }) {
    if (!isValidContact(state, index)) return
    const contactData = Object.assign(state.allContacts[index], { hasInbox: false })
    store.dispatch('contact/updateContact', { contactData, index, updateResult: false })
    state.allContacts.splice(index, 1)
    // state.contactIndex = index < state.allContacts.length ? index : state.allContacts.length - 1
    state.totalCount = state.totalCount - 1
  },
  [SET_HASUNREAD_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].hasUnread = val
  },
  [SET_FIRSTNAME_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].name = val
  },
  [SET_LASTNAME_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].lastName = val
  },
  [SET_BIRTH_DATE_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    const contact = state.allContacts[index]
    const lastIndex = contact.bdayTags.length - 1
    const lastBdayTag = contact.bdayTags[lastIndex] ? contact.bdayTags[lastIndex] : {}
    contact.bdayTags.splice(lastIndex, 1, Object.assign(lastBdayTag, { strValue: val, name: 'birthday' }))
  },
  [SET_BIRTH_YEAR_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].birthyear = val
  },
  [SET_FACEBOOK_URL_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].facebookUrl = val
  },
  [SET_INSTAGRAM_URL_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].instagramUrl = val
  },
  [SET_AVATAR_IMG_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].avatarImg = val
  },
  [SET_GENDER_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].gender = val
  },
  [SET_DESCRIPTION_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].description = val
  },
  [SET_PENDING_STATUS_CODE_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    state.allContacts[index].pendingStatus = val
  },
  [SET_CATEGORY_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    const categorySet = val.map(item => {
      const matchedCategory = store.getters['category/getAllCategories'].find(category => {
        return category.name === item
      })
      return matchedCategory || { name: item }
    })
    state.allContacts[index].categorySet = categorySet
  },
  [SET_GROUP_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    const groupSet = val.map(item => {
      const matchedGroup = store.getters['group/getAllGroups'].find(group => {
        return group.name === item
      })
      return matchedGroup || { name: item }
    })
    state.allContacts[index].groupSet = groupSet
  },
  [SET_ORGANIZATION_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    const contact = state.allContacts[index]
    // push a new empty one
    if (contact.profileWorkHistory.length === 0) {
      const workHistory = {
        organization: {
          name: val
        },
        title: {
          name: ''
        }
      }
      contact.profileWorkHistory.push(workHistory)
    } else if (contact.profileWorkHistory[contact.profileWorkHistory.length - 1].hasOwnProperty('id')) {
      const workHistory = Object.assign({}, contact.profileWorkHistory[contact.profileWorkHistory.length - 1])
      delete workHistory['id']
      workHistory['organization'] = { name: val }
      contact.profileWorkHistory.push(workHistory)
    } else {
      // update the existing one
      const workHistory = contact.profileWorkHistory[contact.profileWorkHistory.length - 1]
      workHistory['organization'] = {
        name: val
      }
    }
  },
  [SET_TITLE_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    // push a new empty one
    const contact = state.allContacts[index]
    if (contact.profileWorkHistory.length === 0) {
      const workHistory = {
        organization: {
          name: ''
        },
        title: {
          name: val
        }
      }
      contact.profileWorkHistory.push(workHistory)
    } else if (contact.profileWorkHistory[contact.profileWorkHistory.length - 1].hasOwnProperty('id')) {
      const workHistory = Object.assign({}, contact.profileWorkHistory[contact.profileWorkHistory.length - 1])
      delete workHistory['id']
      workHistory['title'] = { name: val }
      contact.profileWorkHistory.push(workHistory)
    } else {
      // update the existing one
      const workHistory = contact.profileWorkHistory[contact.profileWorkHistory.length - 1]
      workHistory['title'] = {
        name: val
      }
    }
  },
  [UPDATE_CONTACT_MESSAGE] (state, { smsInstance, statusCode }) {
    // get contact by number
    const isInbound = isInboundMessage(smsInstance)
    const profileNumber = isInbound ? smsInstance.from : smsInstance.to
    let contactIndex = 0
    const contacts = state.allContacts.filter((contact, index) => {
      if (contact.number.replace(' ', '') === profileNumber.replace(' ', '')) {
        contactIndex = index
      }
      return contact.number.replace(' ', '') === profileNumber.replace(' ', '')
    })

    if (contacts.length === 0) {
      state.queryNewContactByNumberVariables = {
        limit: 50,
        offset: 0,
        orderBy: '-last_sms_at,-id',
        isDelete: 0,
        hasInbox: true,
        number: getQueryContactNumber(profileNumber)
      }
      state.queryingNewContact = true

      // state.queryNewContactByNumberVariables.number = getQueryContactNumber(profileNumber)
      // if (state.skipQueryNewContact) {
      //   state.skipQueryNewContact = false
      // }
    } else if (contacts.length === 1) {
      const receivedContact = contacts[0]
      // update sms body
      receivedContact.lastSmsBody = smsInstance.numMedia
        ? smsInstance.body || `MMS: ${smsInstance.numMedia} file` : smsInstance.body
      // update status
      if (statusCode !== null) {
        receivedContact.pendingStatus = statusCode
      }
      // change contact position
      receivedContact.lastSmsAt = new Date(smsInstance.dateSent || smsInstance.dateCreated)
      if (isInbound && state.allContacts[0].lastSmsAt.getTime() < receivedContact.lastSmsAt.getTime()) {
        const firstContact = Object.assign(state.allContacts[0])
        state.allContacts.splice(0, 1, Object.assign(state.allContacts[contactIndex]))
        state.allContacts.splice(contactIndex, 1, firstContact)
      }
    } else {
      console.error('more than one contact with the same number!')
    }
  },
  [UPDATE_CONTACTS_PENDING_STATUS_CODE] (state, { messageData }) {
    const dict = {}
    messageData.forEach((item) => {
      dict[item.contact_id] = item.pending_status
    })
    state.allContacts.forEach((item) => {
      if (dict[item.id] !== undefined && dict[item.id]) {
        item.pendingStatus = dict[item.id]
      }
    })
  },
  [SET_CONTACT_SELECTED_BY_INDEX] (state, { val, index }) {
    if (!isValidContact(state, index)) return
    const contact = state.allContacts[index]
    contact.selected = val
  },
  [SET_INDEX] (state, { val }) {
    // console.log('set index')
    if (isValidContactIndex(state, val)) {
      state.contactIndex = val
    }
  },
  [SET_QUERYING_UPDATE_NEW_CONTACT] (state, { val }) {
    state.queryingNewContact = val
  },
  [SET_QUERY_UPDATE_NEW_CONTACT_DISABLED] (state, { val }) {
    state.queryNewContactDisabled = val
  },
  [SET_TOTAL_COUNT] (state, { val }) {
    state.totalCount = val
  },
  [SET_QUERY_COUNT] (state, { val }) {
    state.totalQueriedCount = val
  },
  [CLEAR_SEARCH] (state) {
    state.queriedContacts = []
    state.status.searching = false
    state.totalQueriedCount = 0
  },
  [CLEAR] (state) {
    state.allContacts = []
    state.queriedContacts = []
    state.contactIndex = 0
    state.status = {
      loading: false,
      message: 'Loading',
      searching: false
    }
    state.totalCount = 0
    state.totalQueriedCount = 0
  }
}

// test
export const contactMapGettersTest = {
  contactTotalCount: 'contact/getTotalCount',
  contactImgByIndex: 'contact/getAvatarImgByIndex',
  contactTitleByIndex: 'contact/getTitleByIndex',
  contactOrganizationByIndex: 'contact/getOrganizationByIndex'
}

export const contact = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
